import { SEO } from "@/components/SEO";
import "@/components/marketing/marketing.css";
export default function PrivacyPage() {
  return (
    <div className="growth">
      <SEO
        title="Website privacy"
        description="How Better Systems AI handles website inquiries and Opportunity Plan submissions."
        url="https://www.bettersystems.ai/privacy"
      />
      <section className="section">
        <div className="wrap" style={{ maxWidth: 800 }}>
          <span className="eyebrow">Better Systems AI</span>
          <h1>Website privacy</h1>
          <p className="muted">Updated September 17, 2026</p>
          <h3>Information you submit</h3>
          <p>
            When you request a plan or contact us, we collect the contact and
            business details you provide, your answers, and campaign information
            included in the page link. We use this to prepare your plan, respond
            to your request, and understand where inquiries come from.
          </p>
          <h3>Storage and service providers</h3>
          <p>
            Submissions are stored in our business records. We use hosting,
            database, and email providers to operate the website and deliver
            responses. Automated spam protection may use request information
            such as an IP address.
          </p>
          <h3>Follow-up</h3>
          <p>
            We may contact you about your request. These forms do not subscribe
            you to a newsletter. We do not sell your submission or add it to a
            client company’s marketing list.
          </p>
          <h3>Your choices</h3>
          <p>
            Contact{" "}
            <a href="mailto:rodolfo@bettersystems.ai">
              rodolfo@bettersystems.ai
            </a>{" "}
            to request access, correction, deletion, or to stop follow-up. We
            may retain records needed for ongoing services, security, or legal
            obligations.
          </p>
          <h3>Other applications</h3>
          <p>
            This notice covers the BSA website forms. Separate application
            privacy notices, including the Soil Seed & Water app notice linked
            in the footer, apply to those products.
          </p>
        </div>
      </section>
    </div>
  );
}
